import { HtmlTemplates } from 'utils/html-templates';
import _, { map } from 'underscore';

export default props => class autocomplete {

    constructor() {
        this.settings = {
            input: '', //es. document.querySelector('#inputTextWithAutocomplete') oggetto / input domNode dove attivare autocomplete
            type: '',
            id: '',
            minLength: 2,   //min lenght input value for to load and show autocomplete list
            apiUrl: SITE_PATH,       //api url for to fetch autocomplete selection list item
            apiParams: { /*sampleParamField1: 'sampleValue1'*/ },       //api params da passare alla fetch
            apiKeywordParamName: 'term', //variabile con la keyword da passare a fetch / default = term
            autocompleteItemsKey: 'nome', //attributo da leggere nella risposta json funzione fetch/append data
            autocompleteItemsValue: 'value',//attributo da leggere nella risposta json funzione fetch/append data
            parseAutocompleteListItemsDescription: item => ( item[this.settings.autocompleteItemsValue] ), //parser x modificare valore stampato in lista autocomplete
            ...props
        };

        this.input = this.settings.input;

        //set autocomplete domNode id
        let randomId = ( 1000 * Math.random()).toString().split('.')[1];
        this.id = (this.settings.id && this.settings.id !== '' && document.querySelector(`#${this.settings.id}`) === null) ? this.settings.id : `autocomplete-component-id-${new Date().getTime()}-${randomId}`;

        //set default type ( html/css modifier )
        if(!this.settings.type || this.settings.type === '') {
            this.settings.type = "autocomplete";
        }

        //exit if input is null
        if(this.input === null || this.input === '') {
            this.notify('autocomplete::errorOnInit' , this);
            return;
        }

        //append autocomplete after input
        this.input.insertAdjacentHTML('afterend', HtmlTemplates.autocomplete({
            type: this.settings.type ,
            id: this.id
        }));

        this.autocomplete =  document.querySelector(`#${this.id}`);

        //exit if autocomplete is not found by id
        if(this.autocomplete === null ) {
            this.notify('autocomplete::errorOnInit' , this);
            return;
        }

        this.loading = false;
        this.autocompleteList = this.autocomplete.querySelector('.autocomplete__list');
        this.autocompleteScrollableTarget = this.autocomplete.querySelector('.autocomplete__list');

        this.appendDataFallback = this.appendDataFallback.bind(this);
        this.appendData = this.appendData.bind(this);
        this.settings.parseAutocompleteListItemsDescription = this.settings.parseAutocompleteListItemsDescription.bind(this);

        this.setListeners();

        this.notify(`autocomplete::ready`, this );
    }

    checkValue(e) {

        let input_val = this.input.value;

        if (input_val.length >= this.settings.minLength) {
            this.fetchData();
        }
        else {
            this.autocompleteList.innerHTML = '';
            this.hide();
        }
    }

    setValue(e) {
        this.input.value = unescape(e.currentTarget.dataset.key);
        this.input.dataset.selectedItem = unescape(e.currentTarget.dataset.item);
        this.autocompleteList.innerHTML = '';
        this.notify('autocomplete::settedValue' , this , JSON.parse(unescape(e.currentTarget.dataset.item)));
        this.hide();
    }

    fetchData() {

        let url = this.settings.apiUrl,
            params = this.settings.apiParams,
            urlWithParams = this.settings.apiUrl.includes('?'),
            addedParams = 0,
            headers = new Headers(),
            credentials = 'same-origin',
            method = 'GET';

        this.loading = true;

        if(params) {

            for(let property in params) {
                url += (!urlWithParams && addedParams === 0) ? "?" : "&";
                url += property + "=" + params[property];
                addedParams++;
            }

            url += (!urlWithParams && addedParams === 0) ? "?" : "&";
            url += `${this.settings.apiKeywordParamName}=${this.input.value}`;
        }

        fetch(url, { method , headers , credentials}).then(function(response){
            return response.json();
        }).then(this.appendData).catch(this.appendDataFallback);
    }

    appendDataFallback(e) {

        this.loading = false;
        this.hide();
        this.notify('autocomplete::errorOnFetech' , this);
    }

    updateAutocompleteList( items = [{}] ) {

        //nb: lista customizzabile tramite key, value and parseAutocompleteListItemsDescription
        //nnb: in data-item è riportato oggetto item originale ricevuto via api
        let output = '',
            autocompleteList;

        for(let item of items) {

            let newItem = {};

            for(let key of Object.keys(item)) {
                newItem[key] = escape(item[key]);
            }

            output += `<li class="autocomplete__item" 
                data-key='${newItem[this.settings.autocompleteItemsKey]}' 
                data-value='${newItem[this.settings.autocompleteItemsValue]}'
                data-item='${JSON.stringify(newItem)}'>${this.settings.parseAutocompleteListItemsDescription(item)}</li>`;
        }

        this.autocompleteList.innerHTML = output;

        autocompleteList = this.autocompleteList.querySelectorAll('li');

        //refresh list items listeners
        for(let item of autocompleteList) {
            item.onclick = this.setValue;
        }

        if(!output) {
            this.hide();
        }
        else {
            this.show();
        }

        this.notify('autocomplete::listUpdated' , this);
    }

    appendData(data = {} ) {

        //todo implementare costumizzazizone -> da sovrascrivere in caso di data differente dal default(codice qui di seguito)
        this.loading = false;

        if( data ) {
            this.updateAutocompleteList(data);
        }
        else {
            this.hide();
        }
    }

    notify( eventName , _this , paramsToNotify = { }) {

        const event = new CustomEvent( eventName , { detail: paramsToNotify } );

        //global event dispatched from document
        document.dispatchEvent(event);

        //local event dispatched from input domNode object
        if( _this === this && this.input ) {
            this.input.dispatchEvent(event);
        }

        console.log(eventName);
    }

    setListeners() {

        //#1 input listen on onkeyup
        this.checkValue = this.checkValue.bind(this);
        //this.input.addEventListener('keyup',this.checkValue, false);
        // _.debounce -> wait user finish type
        this.input.addEventListener('keyup',_.debounce(this.checkValue , 500), false);

        //#2 input listen on autocomplete::updateApiParams
        this.updateApiParams = this.updateApiParams.bind(this);
        this.input.addEventListener('autocomplete::updateApiParams',this.updateApiParams, false);

        //#3 input listen on autocomplete::destroy
        this.destroy = this.destroy.bind(this);
        this.input.addEventListener('autocomplete::destroy',this.destroy, false);

        //#4 input listen on blur
        this.hide = this.hide.bind(this);
        this.input.addEventListener('blur',this.hide, false);

        //#5 input listen on focus
        this.show = this.show.bind(this);
        this.input.addEventListener('focus',this.show, false);

        //#6 input listen on focus with minLength <= 0
        if(!this.settings.minLength || this.settings.minLength < 1) {
            this.input.addEventListener('focus',this.fetchData.bind(this), false);
        }

        //#7 bind this in setValue method used in onClick methods on autocomplete list items
        this.setValue = this.setValue.bind(this);
    }

    updateApiParams(e) {

        const oldParams = this.settings.apiParams;

        this.settings.apiParams = {
            ...oldParams,
            ...e.detail
        };

        this.autocompleteList.innerHTML = '';
        this.hide();

        this.notify('autocomplete::apiParamsUpdated' , this);
    }

    destroy() {

        //#1 rimuovo listener su input keyup
        this.input.removeEventListener('keyup',this.checkValue);

        //#2 rimuovo listener su autocomplete::destroy
        this.input.removeEventListener('autocomplete::destroy',this.destroy);

        //#3 rimuovo listener su blur
        this.input.removeEventListener('blur',this.hide);

        //#4 rimuovo listener su focus
        this.input.removeEventListener('focus',this.show);

        //#5 cancello autocomplete dal dom
        this.autocomplete.remove();

        //#6 rimuovo listener su focus with minLength <= 0
        if(!this.settings.minLength || this.settings.minLength < 1) {
            this.input.removeEventListener('focus',this.fetchData);
        }

        this.notify('autocomplete::destroyed' , this);
    }

    show() {

        if(this.autocomplete === null || this.autocomplete.classList.contains('autocomplete--visible') || this.autocompleteList.innerHTML.trim() === '') return;

        this.autocomplete.classList.add('autocomplete--visible');
        this.autocomplete.classList.remove('autocomplete--hidden');

        if ( Ps !== undefined ) {
            Ps.initialize(this.autocompleteScrollableTarget);
        }

        this.notify(`autocomplete::visible`, this );
    }

    hide() {

        //todo levare delay di 150ms e fare qualcsa di meglio x evitare conflitti tra blur e setValue
        setTimeout(
            () => {
                if(this.autocomplete === null || this.autocomplete.classList.contains('autocomplete--hidden')) return;

                this.autocomplete.classList.add('autocomplete--hidden');
                this.autocomplete.classList.remove('autocomplete--visible');

                if ( Ps !== undefined ) {
                    Ps.destroy(this.autocompleteScrollableTarget);
                }

                this.notify(`autocomplete::hidden`, this );
            }, 150
        );
    }
}


// WEBPACK FOOTER //
// ./cpanel/js/components/autocomplete/modules/autocomplete.js